export function formatSensorData(data) {
  if (data.connection_state && data.connection_state === true) {
    data.connection_state = 'true'
  } else {
    data.connection_state = 'false'
  }
  return data
}
